interface CallTimerProps {
  seconds: number;
}

export function CallTimer({ seconds }: CallTimerProps) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return (
    <span className="font-mono text-sm tabular-nums text-zinc-400">
      {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
    </span>
  );
}
